import {
  PAIDLEAVE_GET_LOCATION_DETAILS,
  PAIDLEAVE_SET_LOCATION
} from './actionTypes'

export const getLocationDetails = id => ({
  type: PAIDLEAVE_GET_LOCATION_DETAILS,
  meta: {},
  payload: { id }
})

export const setLocation = data => ({
  type: PAIDLEAVE_SET_LOCATION,
  meta: {},
  payload: data
})

export default {
  getLocationDetails,
  setLocation
}
